;var CONTACT=(function(my){
  my.init=function(){
    qsa("#contact-form").forEach(form=>{
      form.qsa(".field-container-email input, .field-container-phone input").forEach(input=>{
        input.addEventListener("keyup", emptyFieldToggleClass);
        emptyFieldToggleClass.apply(input, []);
      });
      form.qsa("input[type=tel]").forEach(input=>regexForTelNumber(input));
    });
  };

  var emptyFieldToggleClass = function(evt) {
    if (this.value.length>0) {
      this.removeClass("empty-input");
    } else {
      this.addClass("empty-input");
    }
  };

  var regexForTelNumber = function(input) {
    input.setAttribute("pattern", "[0-9\-\(\)\+\\s]*");
    input.setAttribute("title", "Please enter a valid telephone number.");
  };
  return my;
}(CONTACT || {}));